import React from "react";
import { Result, Button } from "antd";
import { Link } from "react-router-dom";
import Bird404 from "../assets/404.png";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-blue-50 to-blue-100">
      <Result
        icon={
          <img
            src={Bird404}
            alt="404 Bird Not Found"
            className="w-64 h-64 mx-auto"
          />
        }
        title="404 - Bird Not Found"
        subTitle="Looks like this bird flew away... The page you’re looking for doesn’t exist."
        extra={
          <Link to="/">
            <Button type="primary" size="large" className="rounded-xl shadow-md">
              Back to Nest
            </Button>
          </Link>
        }
      />
    </div>
  );
};

export default NotFound;
